import React from 'react'
import './Home.css'


function Home(props) {
    return (
      <div className='container'>
        Signin Successful
      </div>
    )
}

export default Home;